import { Badge } from "@/components/ui/badge";
import AgendaCard from "@/components/agenda/AgendaCard";

export default function AgendaGroup({ group }) {
  if (group.rows.length === 0) return null;
  const Icon = group.icon;
  return (
    <section data-testid={`agenda-group-${group.key}`}>
      <div className="flex items-center gap-2 mb-3">
        <Icon size={18} weight="duotone" />
        <h3 className="font-heading text-lg font-semibold">{group.label}</h3>
        <Badge variant="outline" className="rounded-full border-border">
          {group.rows.length}
        </Badge>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {group.rows.map((item) => (
          <AgendaCard key={item.id} item={item} tone={group.tone} />
        ))}
      </div>
    </section>
  );
}
